import { VoiceConversation } from "@elevenlabs/react";

type ElevenErrorPayload = {
  code?: string | number;
  debug_message?: string;
  details?: unknown;
  error_type?: string;
  message?: string;
  reason?: string;
};

declare global {
  interface Window {
    __roofGeniusElevenLabsErrorPatched?: boolean;
  }
}

if (typeof window !== "undefined" && !window.__roofGeniusElevenLabsErrorPatched) {
  const proto = VoiceConversation.prototype as unknown as {
    handleErrorEvent?: (event: any) => void;
    __roofGeniusPatchedHandleErrorEvent?: boolean;
  };

  const originalHandleErrorEvent = proto.handleErrorEvent;

  if (originalHandleErrorEvent && !proto.__roofGeniusPatchedHandleErrorEvent) {
    proto.handleErrorEvent = function patchedHandleErrorEvent(event: any) {
      const normalizedErrorEvent: ElevenErrorPayload | null =
        event?.error_event ??
        event?.error ??
        (event?.error_type || event?.message || event?.reason
          ? {
              code: event?.code,
              debug_message: event?.debug_message,
              details: event?.details ?? event,
              error_type: event?.error_type ?? "unknown_error",
              message: event?.message,
              reason: event?.reason,
            }
          : null);

      if (!normalizedErrorEvent) {
        console.error("Malformed ElevenLabs error event received:", event);
        const fallbackMessage = "Server error: Unknown error";
        const onError = (this as any)?.onError;

        if (typeof onError === "function") {
          onError(fallbackMessage, {
            details: event,
            errorType: "unknown_error",
          });
        }

        return;
      }

      return originalHandleErrorEvent.call(this, {
        ...event,
        error_event: normalizedErrorEvent,
      });
    };

    proto.__roofGeniusPatchedHandleErrorEvent = true;
  }

  window.__roofGeniusElevenLabsErrorPatched = true;
}